// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
import "@fontsource/permanent-marker"
import "@fontsource/reenie-beanie"
import "@fontsource/mynerve"
import "@fontsource/rock-salt"
import "@fontsource/redacted-script"
import "@fontsource/amatic-sc/400.css"
import "@fontsource/amatic-sc/700.css"
import "@fontsource/roboto-mono/300.css"
import "@fontsource/roboto-mono/400.css"
import "@fontsource/roboto-mono/700.css"
// normalize CSS across browsers
import "./src/normalize.css"
// bootstrap CSS style
import 'bootstrap/dist/css/bootstrap.min.css';
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

const setViewportUnit = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export const onClientEntry = () => {
  setViewportUnit()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', setViewportUnit, { passive: true })
    window.addEventListener('orientationchange', setViewportUnit, { passive: true })
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setViewportUnit)
    }
  }
}

const resetScrollPosition = () => {
  if (typeof window === 'undefined') return

  document.documentElement.style.scrollBehavior = 'auto'
  document.body.style.scrollBehavior = 'auto'
  window.history.scrollRestoration = 'manual'
  window.scrollTo(0, 0)
  window.requestAnimationFrame(() => window.scrollTo(0, 0))
  setTimeout(() => window.scrollTo(0, 0), 50)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

export const onInitialClientRender = () => {
  setViewportUnit()
  resetScrollPosition()
}

export const onPreRouteUpdate = () => {
  if (typeof window === 'undefined') return
  document.documentElement.style.scrollBehavior = 'auto'
  document.body.style.scrollBehavior = 'auto'
  window.scrollTo(0, 0)
}

export const onRouteUpdate = () => {
  resetScrollPosition()
}

export const shouldUpdateScroll = () => {
  if (typeof window === 'undefined') {
    return false
  }

  window.history.scrollRestoration = 'manual'
  return false
}
